import React from 'react'

import eeee1 from '../img/eeee1.png'
import eeee2 from '../img/eeee2.png'
import eeee3 from '../img/eeee3.png'
import eeee4 from '../img/eeee4.png'
import eeee5 from '../img/eeee5.png'
import eeee6 from '../img/eeee6.png'
import eeee7 from '../img/eeee7.png'
import eeee8 from '../img/eeee8.png'
import eeee9 from '../img/eeee9.png'
import eeee10 from '../img/eeee10.png'








import Carousel, { consts } from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faLeftLong , faRightLong } from '@fortawesome/free-solid-svg-icons';

function Texample() {
    const row1 = [
        {
          id: 1,
          img: eeee1,
          title: "syaaraat",
          link: "https://www.syaaraat.com/"
        },
        {
            id: 2,
            img: eeee2,
            title: "Apple",
            link: "https://www.apple.com/sa-ar/iphone/?&mnid=sV18aMKn8-dc_mtid_20925dh764676_pcrid_712895622615_pgrid_167302503516_pexid__ptid_kwd-298221095423_&cid=wwa-ksa-kwgo-iphone--slid---product--Core-Core--&mtid=20925dh764676&aosid=p238"
          },
          {
            id: 3,
            img: eeee3,
            title: "S24",
            link: "https://www.samsung.com/sa/offer/end-of-year/?icid=sa_pd_ppc_google-performance-max_mx-multiple_launch_End-Of-Year-MX_search-performance-max_none_none_lo&utm_source=google-performance-max&utm_medium=shopping-pmax&utm_campaign=End-Of-Year-MX&utm_term=Hot-End-Of-Year-MX&utm_content=none&gad_source=1&gclid=Cj0KCQiA1Km7BhC9ARIsAFZfEItwH7Bw1RCB7QYSYOL8UuMC4JO8yPgLricZtTVSNVl2GHRRvz9pw-AaAmUEEALw_wcB"
          },
          {
            id: 4,
            img: eeee4,
            title: "H6",
            link: "https://www.haval.com.sa/ar/car-models/h6"
          },
          {
            id: 5,
            img: eeee5,
            title: "alhudhyaf",
            link: "https://alhudhyaf.com/?gad_source=1&gclid=Cj0KCQiA1Km7BhC9ARIsAFZfEIttHgPTTAPEIlj6-xjQtiW9QhzQ-458Q2_LvkmbnsHEfQYX-DJVvEAaAr7sEALw_wcB"
          },
          {
            id: 6,
            img: eeee6,
            title: "saptco",
            link: "https://www.saptco.com.sa/"
          },
          {
            id: 7,
            img: eeee7,
            title: "STC",
            link: "https://www.stc.com.sa/content/stc/sa/ar/personal/home.html"
          },
          {
            id: 8,
            img: eeee8,
            title: "my.gov.sa",
            link: "https://www.my.gov.sa/wps/portal/snp/main"
          },
          {
            id: 9,
            img: eeee9,
            title: "alrajhitakafu",
            link: "https://www.alrajhitakaful.com/ar"
          },
          {
            id: 10,
            img: eeee10,
            title: "Ahmed Zaakan",
            link: "https://ahmed-zaakan.netlify.app/"
          },
      ]
    
      const responsive = {
        superLargeDesktop: {
          // screens larger than 1920px
          breakpoint: { max: 4000, min: 1920 },
          items: 3
        },
        desktop: {
          // screens larger than 1024px
          breakpoint: { max: 1920, min: 1024 },
          items: 3
        },
        tablet: {
          // screens larger than 464px
          breakpoint: { max: 1024, min: 464 },
          items: 2
        },
        mobile: {
          // screens smaller than 464px
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
      };
    
      const CustomButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
        const { carouselState: { currentSlide } } = rest;
        return (
          <div className="custom-button-group">
            <button onClick={() => previous()} className="custom-arrow left">
            <FontAwesomeIcon icon={faRightLong} className='exampleicon'/>
             </button>
            <button onClick={() => next()} className="custom-arrow right">
            <FontAwesomeIcon icon={faLeftLong} className='exampleicon'/>
              </button>
          </div>
        );
      };
  return (
    <div className='example2 example'>
    <div className="container">
      <Carousel 
        responsive={responsive} 
        autoPlay={true}
        autoPlaySpeed={7000}
        infinite={true}
        customButtonGroup={<CustomButtonGroup />}
        renderButtonGroupOutside={true}
        arrows={false}
        className='m--20'
      >
        {row1.map((item, index) => (
          <div key={index} className="mockup mockup-macbook m-4">
                <a href={item.link} target='_blank' rel="noopener noreferrer">
                  <img src={item.img} alt={item.title} className='imgexample imgtexample d-block mx-auto' />
                </a>
              </div>
        ))}
      </Carousel>
    </div>
  </div>
  )
}

export default Texample
